import { ofetch } from 'ofetch';
import { useUserStore } from '../stores/userStore';
import { handleBackendError } from '../utils/errors';

const APIClient = ofetch.create({
    async onRequest ({ options }) {
        const token = await useUserStore().getJWT();
        if (options.headers instanceof Headers) {
            options.headers.set('Authorization', `Bearer ${token}`);
        }
    },
    onResponseError ({ response, options }) {
        if ((options as unknown as Record<string, unknown>).silent) { return; }
        const responseData = response._data;
        if (typeof responseData === 'string') {
            handleBackendError(responseData, response.status);
        } else if (responseData && typeof responseData === 'object') {
            handleBackendError(JSON.stringify(responseData), response.status);
        }
    }
});

export { APIClient };

export const buildQueryParamsString = (queryObject: object | undefined | null) => {
    if (!queryObject) {
        return '';
    }

    const kvPairs = Object.entries(queryObject)
        .filter(([key, value]) => key && value)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

    return kvPairs ? `?${kvPairs}` : '';
};
